/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(['jquery'], function($) {
    return {
        /**
         * @param {CanvasRenderingContext2D} context
         * @param {number} shape
         * @param {LegendModel} legend
         * @param {number} arrowWidth
         * @param {number} width
         */
        render: function(context, legend, shape, arrowWidth, width) {
            context.textAlign = 'center';
            context.textBaseline = 'middle';
            context.fillText(legend.get('text'), width / 2, legend.get('topOffset'));
            this.drawArrow(
                context,
                legend.get('widthOffset') + arrowWidth,
                legend.get('topOffset'),
                legend.get('widthOffset'),
                legend.get('topOffset')
            );
            this.drawArrow(
                context,
                width - legend.get('widthOffset') - arrowWidth,
                legend.get('topOffset'),
                width - legend.get('widthOffset'),
                legend.get('topOffset')
            );
        },

        /**
         * @param {CanvasRenderingContext2D} context
         * @param {number} fromX
         * @param {number} fromY
         * @param {number} toX
         * @param {number} toY
         */
        drawArrow: function(context, fromX, fromY, toX, toY) {
            var headLength = 10;
            var angle = Math.atan2(toY - fromY, toX - fromX);
            context.beginPath();
            context.moveTo(fromX, fromY);
            context.lineTo(toX, toY);
            context.stroke();
            context.beginPath();
            context.moveTo(toX - headLength * Math.cos(angle - Math.PI / 6), toY - headLength * Math.sin(angle - Math.PI / 6));
            context.lineTo(toX, toY);
            context.lineTo(toX - headLength * Math.cos(angle + Math.PI / 6), toY - headLength * Math.sin(angle + Math.PI / 6));
            context.fill();
        }
    };
});
